import React from "react";

import { FaqBlocks } from "components/faq-blocks";
import Heading from "components/heading";
import HeroSection from "components/hero-section";

import { faqData } from "./data";

const title = "Everything You Need To Know About The Enerflo OS";

const FaqSection = () => {
  return (
    <HeroSection title={title}>
      <HeroSection.Content>
        <div className="text-center mb-12">
          <HeroSection.Tagline className="text-primary mb-4">{title}</HeroSection.Tagline>
          <Heading tag="h2" className="max-w-2xl mx-auto text-navy-dark">
            <span>Frequently Asked Questions:</span>
            <br />
            <span className="text-primary inline-block mt-2">
              Residential Solar Software & The Enerflo Operating System
            </span>
          </Heading>
        </div>

        <FaqBlocks items={faqData} />
      </HeroSection.Content>
    </HeroSection>
  );
};

export default FaqSection;
